// Phone side of "one paired phone per match": the waiting screen between
// signatures (signing_devices#show).
//
// Deliberately belt and braces. The websocket gets the request across
// instantly, the poll is what makes it survive arena wifi — before this
// feature the phone needed no live connection at all (the QR was a plain URL),
// so a push that only arrives over ActionCable would be a step backwards. The
// poll doubles as the heartbeat behind the keeper's "phone connected" badge.

global.signingDevice = {
  data: { nextUrl: null, token: null, navigating: false },
  POLL_MS: 5000,

  init: function(nextUrl, token) {
    signingDevice.data.nextUrl = nextUrl;
    signingDevice.data.token = token;

    ws.subscribe("SigningChannel", { token: token }, signingDevice.onEvent);
    signingDevice.poll();
    setInterval(signingDevice.poll, signingDevice.POLL_MS);
  },

  onEvent: function(data) {
    if(!data) return;
    if(data.action == 'sign' && data.url) {
      signingDevice.go(data.url);
    } else if(data.action == 'unpaired') {
      window.location.reload();
    }
  },

  poll: function() {
    if(signingDevice.data.navigating) return;
    $.ajax(signingDevice.data.nextUrl, {
      method: 'GET',
      success: function(data) {
        signingDevice.setLink(true);
        if(data.status == 'sign' && data.url) {
          signingDevice.go(data.url);
        } else if(data.status == 'expired') {
          window.location.reload();   // renders the "pairing expired" screen
        }
      },
      error: function() {
        signingDevice.setLink(false);
      }
    });
  },

  // The poll is the heartbeat, so it is also the honest answer to "is this phone
  // still reachable". Without this the waiting screen looked identical whether
  // the network was there or not — on the page whose whole reason for polling is
  // that arena wifi drops.
  setLink: function(online) {
    $('#signing-link').toggleClass('is-online', online).toggleClass('is-offline', !online);
  },

  go: function(url) {
    if(signingDevice.data.navigating) return;
    signingDevice.data.navigating = true;
    window.location = url;
  }
};
